import { Link } from "@tanstack/react-router"
import { LockIcon } from "lucide-react"

import { Button } from "@/components/ui/button"
import { Card, CardTitle } from "@/components/ui/card"

type CreateNewFundingRequestCardProps = {
  disabled: boolean
}

export default function CreateNewFundingRequestCard({
  disabled,
}: CreateNewFundingRequestCardProps) {
  return (
    <Card className="@container min-w-0 overflow-hidden p-6">
      <div className="grid h-full grid-cols-1 grid-rows-[auto_1fr] gap-4 @md:grid-cols-[1fr_auto]">
        <CardTitle className="leading-tight @md:col-span-2">
          Create a New Funding Request
        </CardTitle>

        <div className="flex flex-col justify-between">
          <p className="mb-4">
            Easily start a new funding request for your company.
          </p>
          {disabled ? (
            <Button disabled className="bg-primary self-start">
              View
              <LockIcon className="ml-2 h-4 w-4" />
            </Button>
          ) : (
            <Button className="bg-primary self-start" asChild>
              <Link to="/funding-requests">View</Link>
            </Button>
          )}
        </div>
      </div>
    </Card>
  )
}
